<template>
  <div id="LoanInvesting">
    <LoanCancelButton :status="status" />
    <div class="investing">
      <v-icon
        medium
        class="refresh"
        @click="getLoanInvestingAmount"
        color="primary darken-2"
      >
        mdi-autorenew
      </v-icon>
      <v-progress-circular
        :size="240"
        width="10"
        rotate="-90"
        :value="investingAmountRate"
      >
        <div class="progress">
          <div class="title">
            <span>{{ statusTitle }}</span>
          </div>
          <div class="amount">
            <div class="top">{{ investingAmount | commaFormat }} <span>원</span></div>
            <div class="bottom" v-if="!isLoanExecuting && (loan && loan.amount)">/ {{ loan.amount | commaFormat }} <span>원 신청</span></div>
          </div>
        </div>
      </v-progress-circular>
      <div class="button">
        <button @click="contract" :disabled="isDisabled" v-if="status" :class="{'temp-error-msg-button': isErrorExecute}">
          {{ statusDown }}
          <v-progress-circular
            v-if="isContractLoading"
            style="padding-left: 15px;"
            size="24"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </button>
      </div>
      <!-- <div class="button">
        <v-btn v-if="mode !== 'production'" :to="{path: '/woori-crowd', query: { autoRedirect: false } }" block large color="#1baaf1">
          우리동네 크라우드 펀딩
        </v-btn>
        <v-btn v-else to="/woori-crowd" block large color="#1baaf1">
          우리동네 크라우드 펀딩
        </v-btn>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import LoanService from '@/service/loan/LoanService'
import StatusService from '@/service/status/StatusService'
import contractsApi from '@/api/now/contractsApi'
import loanApi from '@/api/now/loanApi'

const NOT_CONTRACTABLE = 'not contractable'

export default {
  name: 'LoanInvesting',
  components: {
    LoanCancelButton: () => import('./LoanCancelButton.vue')
  },
  props: {
    status: {
      type: Object
    },
    offer: {
      type: Object
    },
    possibleAmount: {
      type: Number
    },
    leftAmount: {
      type: Number
    },
  },
  data() {
    return {
      loan: null,
      loansRequest: null,
      isContractDisable: false,
      isContractLoading: false,
      investingAmount: 0,
      investingAmountRate: 0.0,
      minimumRestInvestAmount: LoanService.MINIMUM_REST_INVEST_AMOUNT,
      isErrorExecute: false
    }
  },
  async created() {
    this.loan = await LoanService.getCurrentLoan()
    this.getIsErrorExecute()

    await this.getLoanInvestingAmount()
    this.isContractDisable = await LoanService.isLoanContractDisable()
    if (this.isInCapableToInvest && !this.isInvestmentCollectedAll) {
      this.setStatusMessage('신청 금액과 모집 금액의 차이가 5천원 미만일 경우 자동으로 투자 마감됩니다.')
    }
    if (this.userProfile.store.is_closed) {
      this.setStatusMessage(`${this.userProfile.name} 사장님! 휴/폐업사실이 확인되어 대출 진행이 불가합니다.`)
    }
    // loan으로 loansRequest 조회
    const { data } = await loanApi.getLoansRequestByLoan(this.loan.uuid)
    this.loansRequest = data
  },
  computed: {
    ...mapState('auth', {
      userProfile: 'profile'
    }),
    ...mapState('env', ['mode']),
    isLoanExecuting() {
      return this.status.code === StatusService.statuses.EXECUTING.code
    },
    isLoanInvested() {
      return this.status.code === StatusService.statuses.INVESTED.code
    },
    isInvestmentCollectedAll() {
      return this.investingAmount === this.loan.amount
    },
    isInCapableToInvest() {
      return (this.loan.amount - this.investingAmount) < this.minimumRestInvestAmount
    },
    isDisabled() {
      // 당분간 당일기표 막음 계약서 작성 가능 시간일때에만 작성할수있게
      return !this.canContract || this.isContractDisable || this.investingAmount === 0 || this.isLoanExecuting || this.isContractLoading || this.isErrorExecute || this.userProfile.store.is_closed
    },
    canContract() {
      // isstoreclosed일 때 false
      if (!this.loan || this.userProfile.store.is_closed) {
        return false
      }
      let now = new Date()
      let nowTime = now.getTime()
      let contractStartTime = new Date(this.loan.contract_start_time)
      let contractEndTime = new Date(this.loan.contract_end_time)
      // loansRequest가 존재하고 loansRequest가 approved가 아니면 계약서 작성불가
      if (this.loansRequest && this.loansRequest.status !== 'approve') {
        return false
      }

      // 우리동네 크라우드 상품은 금액 모이면 일찍 계약서 작성 가능
      if (
        ['woori_crowd'].includes(this.loan?.offer?.loan_type) &&
        this.loan.amount - this.investingAmount < 5000
      ) {
        return nowTime <= contractEndTime.getTime()
      }

      return (contractStartTime.getTime() <= nowTime && nowTime <= contractEndTime.getTime())
    },
    statusTitle() {
      let statusTitle = this.status.top
      if (this.loan && !this.canContract) {
        if (!this.isLoanExecuting && this.isInvestmentCollectedAll) {
          statusTitle = '투자 모집 완료'
        }
      } else {
        if (!this.isLoanExecuting) {
          statusTitle = '투자 마감 완료'
        }
      }
      return statusTitle
    },
    statusDown() {
      if (this.isErrorExecute) {
        // return '장애로 송금이 지연되고 있으며, 복구되는대로 송금 진행예정입니다.'
        // 계약서 작성 완료되었는데 투자모집상태일때 안내문구 변경
        return '계약서 작성이 완료되어, 오후 4시이후 순차 송금이 진행됩니다.'
      }
      let result = this.status.down

      // 당분간 당일기표 불가
      if (this.loan && this.canContract && !this.isLoanExecuting) {
        result = '계약서 작성하기'
      }
      if (this.userProfile.store.is_closed) {
        result = StatusService.statuses.CLOSEDSTATUS.down
      }
      // if ((this.canContract && !this.isLoanExecuting) || this.isInCapableToInvest) {
      //   result = '계약서 작성하기'
      // }
      return result
    },
  },
  methods: {
    ...mapActions('status', {
      setStatusMessage: 'setStatusMessage'
    }),
    async getIsErrorExecute() {
      if (!this.loan || this.loan.status !== 'invested') {
        return
      }

      const { data } = await contractsApi.getAgreements()
      if (!data || data.length === 0) {
        return
      }

      const loanContract = data.find(agreement => agreement.offer && agreement.offer.uuid === this.loan.offer.uuid)
      if (loanContract && loanContract.is_agreed && loanContract.signature && loanContract.image) {
        this.isErrorExecute = true
      }
    },
    async getLoanInvestingAmount() {
      this.investingAmount = await LoanService.getLoanInvestingAmount() || 0
      let investingAmountRate = (this.investingAmount / this.loan.amount) * 100

      if (this.isLoanExecuting) {
        this.investingAmountRate = 0
      } else {
        this.investingAmountRate = isNaN(investingAmountRate) ? '0' : investingAmountRate
      }
    },
    async closeFunding() {
      await LoanService.closeFunding()
      await StatusService.syncStatus()
      if (this.status.code === StatusService.statuses.INVESTED.code) {
        this.$router.push({ name: this.status.route })
      } else {
        throw Error({
          error: NOT_CONTRACTABLE
        })
      }
    },
    async closedStore() {
      // 비동기 형식으로 불러오고
      this.closed_store = await LoanService.getClosedStoreStatus()
      console.log(this.closed_store) // 뭔가 if문 써서 return을 해야할 거 같기도 한데...
    },
    async contract() {
      if (this.isContractLoading) {
        return
      }

      try {
        this.isContractLoading = true

        if (!this.canContract) {
          this.$swal.fire({
            html: '계약서를 작성 가능한 시간이 아닙니다',
            confirmButtonText: '확인'
          })
          return
        }

        await this.closeFunding()
        // 당분간 당일기표 막음
        // if (!this.canContract && !this.isLoanInvested && !this.isInCapableToInvest) {
        //   let result = await this.$swal.fire({
        //     html: '다음 날 오전 10시까지 기다리시면 지금 보다 더 많은 금액이 모집 될 수 있어요.',
        //     showCloseButton: false,
        //     showCancelButton: true,
        //     focusConfirm: false,
        //     icon: 'warning',
        //     confirmButtonText: '기다리기',
        //     cancelButtonText: '지금 받기',
        //   })

        //   if (result.isDismissed) {
        //     await this.closeFunding()
        //   } else if (result.isConfirmed) {
        //     return
        //   }
        // } else {
        //   await this.closeFunding()
        // }
      } catch (e) {
        if (e) {
          this.$swal.fire({
            html: '문제가 발생했습니다',
            confirmButtonText: '확인'
          })
        }
      } finally {
        this.isContractLoading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#LoanInvesting {
  margin-top: 35px;
  margin-bottom: 30px;

  .temp-error-msg-button {
    padding: 15px;
    height: auto !important;
  }

  .title {
    color: #333333;
    font-size: 17px;
    font-weight: 900;
  }

  .amount {
    margin-top: 18px;
    margin-bottom: 18px;
  }

  .button {
    margin-top: 25px;

    button {
      width: 100%;
      color: #ffffff;
      background-color: #1baaf1;
      height: 50px;
      border-radius: 6px;
      font-weight: 700;
    }
  }

  .investing {
    margin-top: 18px;
    margin-bottom: 18px;
    position: relative;
    text-align: center;

    .title {
      text-align: center;
    }
    .amount {
      text-align: center;
    }

    .refresh {
      position: absolute;
      right: 0;
      top: -25px;
    }

    .v-progress-circular {
      color: #1baaf1;

      &__info {
        .progress {
          .title {
            font-weight: 600;
          }
          .amount {
            .top {
              color: #333333;
              font-size: 32px;
              font-weight: 900;
              letter-spacing: -1.2px;

              span {
                font-size: 12px;
              }
            }
            .bottom {
              color: #a6a6a6;
              font-size: 16px;
              font-weight: 600;

              span {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

  .summary {
    margin-top: 18px;

    dl {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;

      dt {
        font-size: 15px;
        font-weight: 600;
        color: #6e7c91;
      }

      dd {
        font-size: 17px;
        font-weight: 900;
        letter-spacing: -0.5px;
        color: #16191d;
      }
    }
  }
}
</style>
